export default __webpack_public_path__ + "static/mb-product-desktop-685a39f1dd4f5684768a91e7dff57fac.png";